import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactWrapperComponent } from './components/react-wrapper/react-wrapper.component';
import { Title } from '@angular/platform-browser';
import { appTitle } from '../environments/environment';
import { AppRoutes } from './App';
import { firstValueFrom, map } from 'rxjs';
import { DocKind } from './free-templates/types';
import { EmploymentAgreementDialogComponent } from './company/files/company-documents/components/employment-agreement-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { GqlCompany } from './graphql/base-types.graphql';

@Component({
  selector: 'app-root',
  template: `<app-react-wrapper [component]="App" [props]="{ showNewDocumentDialog }" />`,
  imports: [ReactWrapperComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  App = AppRoutes;

  constructor(
    titleService: Title,
    private dialog: MatDialog,
  ) {
    titleService.setTitle(appTitle);
  }

  public showNewDocumentDialog = async (
    kind: DocKind,
    company: Pick<GqlCompany, 'id' | 'name' | 'organizationNumber' | 'addressAsStr'>,
  ): Promise<boolean> => {
    switch (kind) {
      case DocKind.PermanentEmployment:
      case DocKind.ManagingDirector: {
        return firstValueFrom(
          EmploymentAgreementDialogComponent.open(this.dialog, {
            docKind: kind,
            company,
          })
            .afterClosed()
            .pipe(map(() => true)),
        );
      }
      default: {
        return false;
      }
    }
  };
}
